import { Directive, Input, ElementRef, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NG_VALIDATORS, Validator, UntypedFormControl } from '@angular/forms';
import { FormsValidators } from '../validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[greaterThan]',
  providers: [{ provide: NG_VALIDATORS, useExisting: GreaterThanValidatorDirective, multi: true }],
})
export class GreaterThanValidatorDirective implements Validator {
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  @Input() greaterThan!: string | number;

  validate(c: UntypedFormControl) {
    return FormsValidators.greaterThan(+this.greaterThan)(c);
  }
}
